import { useEffect } from 'react';
import { createElement } from 'react';
import './style.less';
function Card(props) {
    const { title, message, img, onComplete } = props;
    useEffect(() => {
        onComplete?.();
    }, []);
    return (createElement("div", { className: "card-wrapper" },
        createElement("div", { className: "poster" }, img),
        createElement("div", { className: "content" },
            createElement("p", { className: "title" }, title),
            createElement("p", { className: "message" }, message))));
}
export default Card;
